/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Merge_TitleInputs */

const en_speaker_manager_merge_title = /** @type {(inputs: Speaker_Manager_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge Speakers`)
};

const fr_speaker_manager_merge_title = /** @type {(inputs: Speaker_Manager_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner les locuteurs`)
};

const de_speaker_manager_merge_title = /** @type {(inputs: Speaker_Manager_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenführen von Sprechern`)
};

const it_speaker_manager_merge_title = /** @type {(inputs: Speaker_Manager_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci altoparlanti`)
};

const ru_speaker_manager_merge_title = /** @type {(inputs: Speaker_Manager_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объединить докладчиков`)
};

const es_speaker_manager_merge_title = /** @type {(inputs: Speaker_Manager_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionar oradores`)
};

const zh_cn2_speaker_manager_merge_title = /** @type {(inputs: Speaker_Manager_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并演讲者`)
};

const ja_speaker_manager_merge_title = /** @type {(inputs: Speaker_Manager_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーを結合する`)
};

const hi_speaker_manager_merge_title = /** @type {(inputs: Speaker_Manager_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ताओं को मर्ज करें`)
};

const pt_pt2_speaker_manager_merge_title = /** @type {(inputs: Speaker_Manager_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unir alto-falantes`)
};

/**
* | output |
* | --- |
* | "Merge Speakers" |
*
* @param {Speaker_Manager_Merge_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_merge_title = /** @type {((inputs?: Speaker_Manager_Merge_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Merge_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speaker_manager_merge_title(inputs)
	if (locale === "de") return de_speaker_manager_merge_title(inputs)
	if (locale === "it") return it_speaker_manager_merge_title(inputs)
	if (locale === "ru") return ru_speaker_manager_merge_title(inputs)
	if (locale === "es") return es_speaker_manager_merge_title(inputs)
	if (locale === "zh-CN") return zh_cn2_speaker_manager_merge_title(inputs)
	if (locale === "ja") return ja_speaker_manager_merge_title(inputs)
	if (locale === "hi") return hi_speaker_manager_merge_title(inputs)
	if (locale === "pt-PT") return pt_pt2_speaker_manager_merge_title(inputs)
	return en_speaker_manager_merge_title(inputs)
});